<template>
  <div>
    <CreateSoftwareUpdateDialog
      :dialog="showCreateSoftwareUpdateDialog"
      @close="closeCreateSoftwareUpdateDialog"
    >
    </CreateSoftwareUpdateDialog>

    <CreateSoftwareUpdateScheduleDialog
      :dialog="showCreateSoftwareUpdateScheduleDialog"
      :schedule="schedule"
      :countsByDay="scheduledCountsByDay"
      @close="closeCreateSoftwareUpdateScheduleDialog"
    >
    </CreateSoftwareUpdateScheduleDialog>

    <CreateGtpsSoftwareUpdateDialog
      :dialog="showCreateGtpsSoftwareUpdateDialog"
      @close="closeCreateGtpsSoftwareUpdateDialog"
    >
    </CreateGtpsSoftwareUpdateDialog>

    <v-card height="775px" style="position:relative;padding-bottom:50px">
      <v-toolbar
        color="grey darken-3"
        dark
        flat
      >
        <v-toolbar-title>Software Versions</v-toolbar-title>
        <template v-slot:extension>
          <v-tabs
            v-model="tab"
            align-with-title
            background-color="transparent"
            grow
          >
            <v-tabs-slider color="red"></v-tabs-slider>

            <v-tab>Aligners - {{latestSoftwareVersion}}</v-tab>
            <v-tab>Tru-Point - {{latestGtpsSoftwareVersion}}</v-tab>
            <!--<v-tab>EZ ADAS</v-tab>-->
          </v-tabs>
        </template>
      </v-toolbar>

      <v-tabs-items
        v-model="tab"
      >
        <v-tab-item>
          <AlignerSoftware ref="active"/>
        </v-tab-item>
        <v-tab-item>
          <GtpsSoftware ref="active"/>
        </v-tab-item>
        <!--
        <v-tab-item>
          <EzAdasSoftware ref="active"/>
        </v-tab-item>
        -->
      </v-tabs-items>

      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn
          color="grey lighten-1"
          @click.stop="openCreateSoftwareUpdateDialog()"
          v-if="tab === 0 && canShowCreateSoftwareUpdate"
        >
          Create Aligner Update
        </v-btn>
        <v-btn
          color="grey lighten-1"
          @click.stop="openCreateSoftwareUpdateScheduleDialog()"
          v-if="tab === 0 && canShowCreateSoftwareUpdateSchedule"
        >
          Schedule Aligner Updates
        </v-btn>

        <v-btn
          color="grey lighten-1"
          @click.stop="openCreateGtpsSoftwareUpdateDialog()"
          v-if="tab === 1 && canShowCreateSoftwareUpdate"
        >
          Create Tru-Point Update
        </v-btn>

      </v-card-actions>

    </v-card>

  </div>
</template>

<script>
import CreateSoftwareUpdateDialog from '../components/software_updates/CreateSoftwareUpdateDialog.vue';
import CreateSoftwareUpdateScheduleDialog from '../components/software_updates/CreateSoftwareUpdateScheduleDialog.vue';
import CreateGtpsSoftwareUpdateDialog from '../components/software_updates/CreateGtpSoftwareUpdateDialog.vue';

import AlignerSoftware from '../components/software_updates/AlignerSoftware.vue';
import GtpsSoftware from '../components/software_updates/GtpsSoftware.vue';

export default {
  components: {
    CreateSoftwareUpdateDialog,
    CreateSoftwareUpdateScheduleDialog,
    CreateGtpsSoftwareUpdateDialog,
    AlignerSoftware,
    GtpsSoftware,
  },

  data() {
    return {
      tab: 0,

      showCreateSoftwareUpdateDialog: false,
      showCreateSoftwareUpdateScheduleDialog: false,
      showCreateGtpsSoftwareUpdateDialog: false,
      schedule: {},
      scheduledCountsByDay: {},
    };
  },

  computed: {
    canShowCreateSoftwareUpdate() {
      return (
        this.$store.state.auth.token
        && (
          this.$store.state.auth.token.user.role === 'admin'
          || this.$store.state.auth.token.user.role === 'engineer'
        )
      );
    },

    canShowCreateSoftwareUpdateSchedule() {
      return (
        this.$store.state.auth.token
        && (
          this.$store.state.auth.token.user.role === 'admin'
          || this.$store.state.auth.token.user.role === 'engineer'
        )
      );
    },

    latestSoftwareVersion() {
      const { latestSoftwareVersion } = this.$store.state;
      return `${latestSoftwareVersion.semantic}${latestSoftwareVersion.meta ? ` ${latestSoftwareVersion.meta}` : ''}`;
    },

    latestGtpsSoftwareVersion() {
      const { latestGtpsSoftwareVersion } = this.$store.state;
      return `${latestGtpsSoftwareVersion.semantic}${latestGtpsSoftwareVersion.meta ? ` ${latestGtpsSoftwareVersion.meta}` : ''}`;
    },
  },

  methods: {

    openCreateGtpsSoftwareUpdateDialog() {
      this.showCreateGtpsSoftwareUpdateDialog = true;
    },

    closeCreateGtpsSoftwareUpdateDialog() {
      this.showCreateGtpsSoftwareUpdateDialog = false;
    },

    openCreateSoftwareUpdateDialog() {
      this.showCreateSoftwareUpdateDialog = true;
    },

    closeCreateSoftwareUpdateDialog() {
      this.showCreateSoftwareUpdateDialog = false;
    },

    openCreateSoftwareUpdateScheduleDialog() {
      const options = {
        method: 'GET',
        url: '/read/schedule_by_day/v1/',
      };

      this.axios(options)
        .then((res) => {
          this.schedule = res.data.reduce((acc, cur) => {
            if (cur.count <= 10) {
              acc[new Date(`${cur._id.year}-${cur._id.month}-${cur._id.day}`).toISOString().substr(0, 10)] = ['green'];
            } else if (cur.count <= 20) {
              acc[new Date(`${cur._id.year}-${cur._id.month}-${cur._id.day}`).toISOString().substr(0, 10)] = ['yellow'];
            } else {
              acc[new Date(`${cur._id.year}-${cur._id.month}-${cur._id.day}`).toISOString().substr(0, 10)] = ['red'];
            }

            return acc;
          }, {});

          this.scheduledCountsByDay = res.data.reduce((acc, cur) => {
            acc[new Date(`${cur._id.year}-${cur._id.month}-${cur._id.day}`).toISOString().substr(0, 10)] = cur.count;
            return acc;
          }, {});


          this.showCreateSoftwareUpdateScheduleDialog = true;
        })
        .catch((err) => {
          console.error('read/schedule_by_day/v1 --- error');
        });
    },

    closeCreateSoftwareUpdateScheduleDialog() {
      this.showCreateSoftwareUpdateScheduleDialog = false;
    },
  },
};
</script>

<style scoped>
</style>
